<template>
  <div>
    <h3>绝对禁忌症</h3>
    <br />
    <div style="padding-left: 40px">
      <el-row>
        <el-col :span="24">1. 急性心梗(2天内) 或心肌梗塞合并室壁瘤;</el-col>
      </el-row>

      <el-row>
        <el-col :span="24">2. 运动引起加重或影响运动的非心源性疾病;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">3. 中、重度瓣膜病或先天性心脏病;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">4. 未控制的不稳定型心绞痛、症状明显的心力衰竭;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">5. 急性心肌炎、心包炎、风湿热、感染性心内膜炎;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">6. 产生症状或血流动力学障碍的未控制心律失常;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">7. 严重高血压、显著低血压;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">8. 严重的主动脉狭窄;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">9. 肺栓塞、肺梗塞;</el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="highlight">未出现以上绝对禁忌症，并接受运动试验。</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AbsoluteContradictions",
  props: {
    examUuid: String,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.highlight {
  color: red;
}

/* .pad {
  padding-left: 40px;
  padding-right: 40px;
} */

.fr {
  float: right;
}
</style>